import { useEffect, useState } from 'react';
import axios from 'axios';

export const ROLE_LABELS = {
  suser: 'Administratorius',
  organization: 'Organizacija'
};

export const hasRole = (userData, role) => {
  const r = userData?.role;
  if (Array.isArray(r) || typeof r === 'string') return r.includes(role);
  return false;
};

export const getFullName = (userData) => [userData?.name, userData?.surname].filter(Boolean).join(' ');

export const getInitials = (userData) => {
  const letters = [userData?.name, userData?.surname].filter(Boolean).map((s) => String(s).trim()[0]);
  return letters.join('').toUpperCase() || '?';
};

export const getRoleLabel = (userData) => {
  const roles = Array.isArray(userData?.role) ? userData.role : userData?.role ? [userData.role] : [];
  const known = roles.map((r) => ROLE_LABELS[r]).filter(Boolean);
  return known[0] || '';
};

export const useSessionUser = (userDataProp) => {
  const [fetched, setFetched] = useState(null);

  useEffect(() => {
    if (userDataProp !== undefined) return undefined;
    let cancelled = false;
    axios
      .get('/api/getUserDataFromSession')
      .then((res) => {
        if (!cancelled) setFetched(res.data.response);
      })
      .catch((err) => console.error(err));
    return () => {
      cancelled = true;
    };
  }, [userDataProp]);

  return userDataProp !== undefined ? userDataProp : fetched;
};
